module.exports = __webpack_public_path__ + "static/media/transporte.fbd2ca6e.svg";